const comments = [
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20avatar%20of%20a%20young%20male%20reader%2C%20warm%20friendly%20expression%2C%20simple%20clean%20background%2C%20manga%20fan%20profile%20picture%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    text: '樱花漫画网真的是我每天必刷的漫画平台，全集免费完整版太良心了！下拉式阅读体验比翻页舒服太多了，特别是看长篇全本漫画的时候，一口气能看好几话。韩漫日漫国漫资源都很全，强烈推荐！',
    date: '2026年7月28日',
  },
  {
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20avatar%20of%20a%20young%20female%20reader%2C%20cheerful%20expression%2C%20simple%20warm%20background%2C%20manga%20fan%20profile%20picture%2C%20soft%20dreamy%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    text: '作为一个韩漫爱好者，樱花漫画网的韩漫专区真的太棒了！画风超精致的完整版全本漫画，而且更新速度很快，基本上热门作品都是同步更新的。手机端阅读体验也很流畅，已经推荐给好多朋友了。',
    date: '2026年7月26日',
  },
  {
    name: '老书虫阿强',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20avatar%20of%20an%20adult%20male%20reader%2C%20calm%20friendly%20expression%2C%20simple%20background%2C%20manga%20fan%20profile%20picture%2C%20warm%20natural%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    text: '看了十多年漫画了，樱花漫画网是目前我用过最舒服的漫画阅读平台。全集漫画资源丰富到爆炸，日漫经典和国漫新作都很全。最赞的是完全没有广告干扰阅读，免费完整版下拉式阅读真心好评！',
    date: '2026年7月24日',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          读者评价
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          听听漫画爱好者们怎么说
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900">{comment.name}</h3>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-1 mt-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-400 text-sm"></i>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}